import { OverlayTrigger, Tooltip } from 'react-bootstrap';

interface ITruncateTxtProps {
  id: string;
  txt: string;
  txtClasses?: string;
  size?: number;
}

const TruncateTxt = ({ id, txt, txtClasses, size = 16 }: ITruncateTxtProps) => {
  return (
    <>
      {txt.length > size ? (
        <OverlayTrigger
          overlay={
            <Tooltip id={id}>
              <p>{txt}</p>
            </Tooltip>
          }
        >
          <p className={`clamp-text clamp-line-1 m-0 ${txtClasses || ''}`}>{txt}</p>
        </OverlayTrigger>
      ) : (
        <p className={`clamp-text clamp-line-1 m-0 ${txtClasses || ''}`}>{txt}</p>
      )}
    </>
  );
};

export default TruncateTxt;
